import MonthlySummaryError from './MonthlySummaryError';
class MonthlySummaryInvalidNumberOfBricks extends MonthlySummaryError {
    numberOfBricks;
    constructor(numberOfBricks, options) {
        super('The number of bricks is not a number', options);
        this.numberOfBricks = numberOfBricks;
    }
}
export default MonthlySummaryInvalidNumberOfBricks;
